import { BASE, axiosCall, MethodType } from "./base";

const SETTINGS_BASE = `${BASE}settings/`;
const SETTINGS = `${SETTINGS_BASE}v1/settings`;
const SETTING = `${SETTINGS_BASE}v1/setting`;

function preflight(payload) {
  if (!BASE) {
    console.error("[API] Base API URL is not set.");
    return;
  }

  if (!process.env.VUE_APP_SETTINGS_API_KEY) {
    console.error("[API] Settings API Key is not set.");
    return;
  }

  payload = payload || {};
  //payload.api_key = process.env.VUE_APP_SETTINGS_API_KEY;
  payload.public_key = process.env.VUE_APP_SETTINGS_API_KEY;
  payload.use_cache = process.env.NODE_ENV === "production" ? "true" : "false";
  return payload;
}

/**
 * Reads the settings by making an API call.
 *
 * This function performs a preflight check to obtain the necessary payload.
 * If the preflight check fails, it logs an error message and returns a rejected promise.
 * Otherwise, it constructs the URL with query parameters and makes a GET request using axiosCall.
 *
 * @returns {Promise} A promise that resolves with the API response or rejects if the preflight check fails.
 */
function readSettings() {
  const payload = preflight();

  if (!payload) {
    console.error("[API] Read Content Entries could not run.");
    return Promise.reject();
  }

  let params = new URLSearchParams(payload).toString();
  const url = `${SETTINGS}?${params}`;
  return axiosCall(MethodType.GET, url, payload);
}

/**
 * Updates a setting with the given key and value.
 *
 * @param {Object} param - The parameter object.
 * @param {string} param.key - The key of the setting to update.
 * @param {any} param.value - The new value for the setting.
 * @returns {Promise} - A promise that resolves with the result of the axios call.
 */
function updateSetting({ key, value }) {
  const payload = preflight({ key, value });
  return axiosCall(MethodType.PUT, SETTING, payload);
}

export { readSettings, updateSetting };
